
import axios from 'axios';

export default {

    get(url) {
        const config = {
            method: 'get',
            url,
            withCredentials: true,
            params: {
                t: new Date().getTime()
            }
        }
        return axios(config).then(data => data.data)
    }

}



// WEBPACK FOOTER //
// ./src/js/util.http.axios.js